import styled, { keyframes, css } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateY(100%);
    //opacity: 0;
  }
  to {
    transform: translateY(0);
    //opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

interface IContainer {
  isOpen: boolean;
}

export const Container = styled.div<IContainer>`
  background: var(--white-dark);
  color: var(--black-3);
  padding: 40px 30%;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1001;

  animation: ${slideIn} 0.6s;

  ${({ isOpen }) =>
    !isOpen &&
    css`
      animation: ${slideOut} 0.3s forwards;
    `}

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const Button = styled.div`
  background: transparent;
  margin-bottom: 40px;
  cursor: pointer;
  outline: 0;
`;
